export default __webpack_public_path__ + "static/media/minus_disabled.f2613d9e.svg";